module.exports = __webpack_public_path__ + "static/media/Mall 01.b7bc0b73.webp";